import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext.jsx';
import { MdCalculate, MdCall, MdCode, MdEdit, MdEditDocument, MdFace, MdKey, MdKeyboard, MdLocationCity, MdOutlinePhoneAndroid, MdPhoneAndroid, MdPictureAsPdf, MdQrCode, MdSettings } from "react-icons/md";

import { Create_services } from '../services_root/create_services.js';
import { Randomcode } from '../components_root/rendom_code.js';
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Company_data() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companydata, setCompanydata] = useState([]);
    const [servicesdata, setservicesdata] = useState([]);
    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        const loadCompanyServices = async () => {
            try {
                // 1️⃣ Get all service table definitions
                const servicesDbSnap = await getDocs(
                    collection(db, "servicesdb")
                );

                if (servicesDbSnap.empty) return;

                let allServices = [];

                // 2️⃣ Loop through each service table
                for (const serviceDoc of servicesDbSnap.docs) {
                    const { servicetablename } = serviceDoc.data();
                    if (!servicetablename) continue;
                    const servicesSnap = await getDocs(
                        collection(
                            db,
                            "companies",
                            select_company_uid,
                            servicetablename
                        )
                    );

                    servicesSnap.forEach(doc => {
                        allServices.push({
                            service_table: servicetablename,
                            id: doc.id,
                            ...doc.data(),
                        });
                    });
                }

                setservicesdata(allServices);
            } catch (error) {
                console.error("Error fetching services:", error);
            }
        };

        loadCompanyServices();
    }, []);

    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        const fetchCompany = async () => {
            const docRef = doc(db, "companies", select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const companyData = {
                    id: docSnap.id,
                    ...docSnap.data(),
                };

                setCompanydata([companyData]); // store as array for map()
            } else {
                setCompanydata([]);
            }
        };

        fetchCompany();
    }, []);

    const getExpireDate = (timestamp, days) => {
        if (!timestamp?.toDate || !days) return null;
        const d = timestamp.toDate();
        d.setDate(d.getDate() + days);
        return d.toLocaleDateString();
    };
    const getDueDays = (timestamp, totalDays) => {
        if (!timestamp?.toDate || !totalDays) return 0;

        const startDate = timestamp.toDate();
        const expireDate = new Date(startDate);
        expireDate.setDate(expireDate.getDate() + totalDays);

        const today = new Date();

        const diffTime = expireDate - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">
                    <div className='post-container'>
                        <div className="ui-grid">
                            {servicesdata.map(row => (
                                <div key={row.id} className="ui-items b-1 rounded p-11" >

                                    <table className="b-bottom">
                                        <tbody>
                                            <tr >
                                                <td width={70}>
                                                    <img
                                                        src={row.logo_url}
                                                        alt={row.slug}
                                                        className="service_photo m-1-r rounded"
                                                    />
                                                </td>

                                                <td className="b-bottom ">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="text-h1 text-l bold fcap">
                                                                    {row.slug}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td className="text-h2">
                                                                    {row.date_time?.toDate ? (
                                                                        <>
                                                                            {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                            {row.date_time.toDate().toLocaleTimeString()}
                                                                        </>
                                                                    ) : (
                                                                        <div className="text-h3">Not Billing</div>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td>
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <div
                                                                                        className={
                                                                                            row.mode_test
                                                                                                ? "button-ui2 bold text-h2 red cursor"
                                                                                                : "button-ui2 text-h2 cursor"
                                                                                        }
                                                                                    >
                                                                                        Mode: {row.mode_test ? "Test" : "Production"}
                                                                                        <MdSettings
                                                                                            className="icon"
                                                                                            onClick={() =>
                                                                                                navigate(
                                                                                                    `/company?page=manage&service=${row.servicetablename}&id=${row.serviceid}`
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </td>

                                                                                <td width={50}>
                                                                                    <div
                                                                                        className="button-ui cursor"
                                                                                        onClick={() => navigate(`/${row.slug}`)}
                                                                                    >
                                                                                        Open
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-h3 text-off fcap">Status</td>
                                                <td className={`text-h2 bold ${row.status ? "green" : "red"}`}>
                                                    {row.status ? "Activate" : "Deactivate"}
                                                </td>
                                                <td />
                                            </tr>

                                            <tr>
                                                <td className="text-h3 text-off fcap">Billing date</td>
                                                <td className="text-h2 bold">
                                                    {row.last_bill_date_time?.toDate ? (
                                                        <>
                                                            {row.last_bill_date_time.toDate().toLocaleDateString()}{" "}
                                                            {row.last_bill_date_time.toDate().toLocaleTimeString()}
                                                        </>
                                                    ) : (
                                                        <div className="text-h3">Not Billing</div>
                                                    )}
                                                </td>
                                                <td width={70} className="text-h3 text-r">
                                                    {row.days} Days
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="text-h3 text-off fcap">Expire</td>
                                                <td className="text-h2 bold red">
                                                    {getExpireDate(row.last_bill_date_time, row.days) || "Not Billing"}
                                                </td>
                                                <td width={70} className="text-h3 text-r red bold">
                                                    {getDueDays(row.last_bill_date_time, row.days)} Days
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className='text-h3 text-off fcap m-top'>{row.description}</div>
                                </div>
                            ))}

                        </div>

                    </div>

                </div>
            </div>
        </div >
    );
}
